import config from "@Config/index";
import axios from "axios";

type ParamsProps = {
  base?: string;
  target?: string;
  amount?: number | string;
};

const fetchCurrencyExchangeRates = async ({ base = "", target = "", amount }: ParamsProps = {}) => {
  try {
    if (!base) throw Error("Base currency is requierd");
    const params: ParamsProps = {};
    if (base) params.base = base;
    if (target) params.target = target;
    if (amount != null && amount !== "") params.amount = amount;

    const response = await axios.get(`${config.API_URL}/api/v0/currency_exchange_rates`, {
      params,
    });

    if (response.data && response.data.message === "success") {
      return response.data.data;
    }
  } catch (error) {
    console.log("Error", error);
    return null;
  }

  return null;
};

export default fetchCurrencyExchangeRates;
